import React from "react";
import { useNavigate } from "react-router-dom";
import './index.css'
import quochuy from '../../assets/img/quoc-huy-vector.jpg'
import Footer from "../footer/footer";
function Content () {
     const Navigate  = useNavigate()

  const handleLogin = () => {

    
    Navigate("/dashboard");

  };
    return (
        <div className="content">
            <img src={quochuy} className="quochuy" alt="logo" />
            <div>
                <h5 className="info-province">
                    ủy ban nhân dân tỉnh an giang
                </h5>
                <h2 className="info-name">sở công thương</h2>
                <h4 className="info-data">hệ thống dữ liệu ngành công thương</h4>
            </div>
           <div className="distance">
             <div className="login-container">
                <form>
                    <div className="title-form">

                    <div>
                       <i className="far fa-user-circle icon-account"></i>
                        
                    </div>
                    <div>
                        <h5 className="login-system">Đăng nhập hệ thống</h5>
                    </div>
                    </div>
                    <div className="dot"></div>
                    <div>
                         <h4 className="name-login">Tên đăng nhập</h4>
                       <div className="wrap">
                        <i className="far fa-user icon-user"></i>
                        <input className="input-text" placeholder="Nhập tên đăng nhập"
                        />
                       </div>
                         <h4 className="password">Mật khẩu</h4>
                       <div className="wrap">
                        <i className="fas fa-lock icon-user"></i>
                        <input className="input-text" placeholder="Nhập mật khẩu"
                        />
                        <i className="fas fa-eye icon-eye"></i>
                       </div>
                    </div>
                    <div className="remember-login">
                        <input type="checkbox"/>
                        <h5 >Ghi nhớ đăng nhập</h5>
                    </div>
                    <div className="wrap-button">
                        <i className="fas fa-sign-in-alt icon-login"></i>
                        <button className="login-click"  onClick={handleLogin}>Đăng nhập</button>
                    </div>
                    <div className="forget-password">
                        <h5>Quên mật khẩu?</h5>
                    </div>
                </form>
            </div>
           </div>

           <Footer/>

        </div>
    )
}

export default Content;